<template>
    <div  style="background-color:#fff" >

      <div class="header_container" style="background-color:#fff;opacity:1">
      <van-row type="flex"  justify="space-between" style="height: 40px;">
        <van-row type = "flex" style ="margin:2px" >
          <div><van-image width="40px" :src =" logo"/></div>
          <div class="grid-content"><div>天津大学浙江研究院</div><div>实验室安全教育培训与管理系统</div></div>
        </van-row>
        <div>
          <van-tag type="warning" style="margin-top : 25px"> {{ userInfo.fullName  }} </van-tag>
          <van-tag type="danger" @click="doLogout" style="margin-top : 25px;margin-right: 2px;"> 退出 </van-tag>
          <el-link style="margin-right: 10px;" type="warning" @click.native="goHome()"><i class= "el-icon-s-home"> </i></el-link>
        </div>
      </van-row>
      <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', padding: '0', margin:'2px' }">
      </van-divider>
      </div>
      <van-search style="margin-top : -3px" v-model="storeroomName" shape="round" background="#4fc08d" placeholder="请输入搜索关键词"  show-action>
        <template #label>
          <div >{{type}}</div>
        </template>
        <template #action >
          <span @click="onSearch" >搜索</span>
        </template>
      </van-search>
      <div style="height:calc(80vh - 60px);overflow: auto; background-color: ghostwhite;">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad">
        <div  style="margin : 10px;padding: 5px;  background-color: #fff;" v-for="viewStoreroomForm in storeroomList" :key="viewStoreroomForm.id" >
          <div slot="header"  style="height: 24px;margin: 0; " class="clearfix">
            <van-tag type="primary">{{ viewStoreroomForm.buildingName }}</van-tag>
            <van-tag type="warning">{{ viewStoreroomForm.storeroomName }}</van-tag>
            <van-tag type="success" style="max-width:30%;  white-space:nowrap; overflow:hidden; text-overflow:ellipsis;">{{ viewStoreroomForm.deptName }}</van-tag>
          </div>
          <van-divider  :style="{ color: '#1989fa', borderColor: '#1989fa', margin:'0', padding: '0 0'}"></van-divider>
          <div style ="margin-top: 1px;" >
            <van-tag type="warning" style="width: 75px;text-align: center;">安全等级{{viewStoreroomForm.safeGrade + '级'}}</van-tag>
            <span style ="margin-left: 10px; ">{{ viewStoreroomForm.safeGradeRemark }}</span>
          </div>
          <div style ="margin-top: 5px;display: flex;">
            <div>
              <van-image  v-if = "viewStoreroomForm.headImage != null && viewStoreroomForm.headImage != ''"
              style="width: 50px; height: 50px ; border-radius: 1px;"
              :src="viewStoreroomForm.headImage"
              :fit="'fill'"/>
              <el-avatar v-else  style="display: flex; background-color: rgb(107, 107, 221); height:50px;width: 50px; align-items: center; justify-content: space-around; "> {{ viewStoreroomForm.fullName  }} </el-avatar>
            </div>
            <div style="margin-left: 10px;font-size:12px">
              <div>  
                  姓名: {{viewStoreroomForm.fullName }}({{viewStoreroomForm.userName }})
              </div>
              <div>  
                  电话: {{viewStoreroomForm.phoneNo }}
              </div>
              <div>  
                  邮箱: {{viewStoreroomForm.emial }}
              </div>
            </div>
          </div>
          <div style ="margin-top: 5px; overflow: auto;" >
            <van-tag type="warning" style ="width:75px;text-align: center; font-size:;">安全措施+{{ viewStoreroomForm.safeManageList == null ? 0 :viewStoreroomForm.safeManageList.length }}</van-tag>
            <span style="font-size:12px;margin-left :10px" v-for="(item,index) in viewStoreroomForm.safeManageList" :key="index" >
              {{ (index + 1)+"."+ item.safeManageOption }}
            </span>
          </div>
        </div >
      </van-list>
      </div>
      <!--  -->
    </div>
  </template>
  <script>
    import axios from  '@/api/axiosConfig'
    import {MESSAGE_DURATION } from  '@/api/constant'
    import logo from "@/assets/image/yuanhui.png"
    import { TOKEN_ID } from '@/mutation/mutConst'
    export default {
    name: 'mini_storeroom',
    data() {
        return {
            logo,
            storeroomName: '',
            pageNo: 0,
            totalPageSize: 0,
            type: "实验室",
            storeroomList: [],
            loading: false,
            finished: false,
            userInfo:{
              fullName :'',
              userName :'',
              imageUrl:''
            }
        };
    },
    methods: {
        goHome(){
          this.$router.push({path:'/mini_index'})
        },
        onSearch() {
            setTimeout(() => {
                this.storeroomListLoad(1);
            }, 200);
        },
        onLoad() {
            setTimeout(() => {
                this.storeroomListLoad((this.pageNo + 1));
            }, 200);
        },
        getUserInfo(){
          let url = "/bc/exa/usr/getUsrInfo"
          let dat0 = {
          }
          axios.post(url, dat0).then((response) => {
              if (response.data.code === 0) {
                let dat = response.data.data
                if(dat!= null && dat != ''){
                  this.userInfo.fullName = dat.fullName
                  this.userInfo.usrName = dat.usrName  
                  this.userInfo.imageUrl = dat.headImag
                } else {
                  this.$message({
                    showClose: true,
                    message: '未查询到规章制度信息！',
                    type: 'info',
                    duration: MESSAGE_DURATION
                  })
                }
              }else{
                this.$message({
                  showClose: true,
                  message: response.data.message,
                  type: 'error',
                  duration: MESSAGE_DURATION
                })
              }
              }).catch((err)=>{
                this.$message({
                  showClose: true,
                  message: err.message,
                  type: 'error',
                  duration: MESSAGE_DURATION
                })
              });
        },
        doLogout(){
          let dat = {}
          let url = "/bc/exa/usr/logout"
          let s = JSON.stringify(dat)  
          axios.post(url, s).then((response) => {
            if (response.data.code === 0){
              this.$store.commit(TOKEN_ID, '')
              this.$router.push({path :'/mini_login'})
            } else {
              this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
              })
            }
          }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
            }) 
          })
        },

        storeroomListLoad(pageNo) {
            let url = "/bc/exa/storeroom/storeroomPage";
            let dat = {
                storeroomName: this.storeroomName,
                pageNo,
                pageSize: 20
            };
            axios.post(url, dat).then((response) => {
                this.loading = false;
                this.pageNo = pageNo;
                if (response.data.code === 0) {
                    if (response.data.data.data.length !== 0) {
                        if (pageNo == 1) {
                            this.storeroomList = [];
                        }
                        response.data.data.data.forEach(t => {
                            this.storeroomList.push(t);
                        });
                    }
                    else {
                        this.finished = true;
                        this.$message({
                            showClose: true,
                            message: '未查询到实验室数据！',
                            type: 'warning',
                            duration: MESSAGE_DURATION
                        });
                    }
                }
                else {
                    this.$message({
                        showClose: true,
                        message: response.data.message,
                        type: 'error',
                        duration: MESSAGE_DURATION
                    });
                }
            }).catch((err) => {
                this.pageNo = pageNo - 1;
                this.loading = false;
                this.$message({
                    showClose: true,
                    message: err.message,
                    type: 'error',
                    duration: MESSAGE_DURATION
                });
            });
        },
    },
    created() {
        //setTimeout(()=>{this.noticeListLoad(1),200})
      setTimeout(()=>{ this.getUserInfo()},200)
    },
    components: { 
    }
}
  </script>
  
  <style lang="less" scoped>
      .grid-content{
    margin-top: 4px;
    margin-left: 1px;
    text-align: center;
    font-weight: 700;
    color: #0162c3 ;
    font-size: 0.8em;
  }
  </style>
  


// WEBPACK FOOTER //
// src/mini_pages/mini_storeroom.vue